import { liteClient } from 'algoliasearch/lite';
import SearchPage from './SearchPage';
import { SearchAction, SearchTokenResponse } from './Models';
import { P2GProgress, P2GText } from '@parcel2go/core-ui';
import { useEffect, useState } from 'react';
import { useMeApi } from '../../../lib/api/me/use-me-api';

export interface ISearchProps {
  hit?: SearchAction;
  analyticsTags?: string[];
  hideFilter?: boolean;
  hideSearch?: boolean;
}

const Search: React.FC<ISearchProps> = (props) => {
  const { getSearchToken } = useMeApi();
  const [token, setToken] = useState<SearchTokenResponse>();
  const [client, setClient] = useState<any>();
  const [error, setError] = useState<string>();

  useEffect(() => {
    async function begin() {
      // API Call
      const cfg = await getSearchToken();
      if (cfg && cfg.success && cfg.result) {
        const searchClient = liteClient(cfg.result.application, cfg.result.token);
        setClient(searchClient);
        setToken(cfg.result);
        setError(undefined);
      }
    }
    begin();
  }, [getSearchToken]);

  if (error) {
    return <P2GText colour="error">{error}</P2GText>;
  }

  if (!token || !client) {
    return <P2GProgress />;
  }

  return (
    <SearchPage
      hideFilter={props.hideFilter}
      hideSearch={props.hideSearch}
      client={client}
      indexName={token.indexName}
      hit={props.hit}
      analtyicsTags={props.analyticsTags}
    />
  );
};

export default Search;
